module.exports = __webpack_public_path__ + "ac5a2638adb061dd2777afa76e3a357c.svg";